import { ReactNode, useMemo, useState } from "react";
import { ActiveScreenContext, ActiveScreenState } from "./active-screen.context";

type InterfaceProviderProps = {
  children: ReactNode;
};

const defaultState: ActiveScreenState = {
  screenId: '',
  screenProps: undefined,
  screenData: ''
};

export const InterfaceProvider: React.FC<InterfaceProviderProps> = ({ children }) => {
  const [state, setState] = useState<ActiveScreenState>(defaultState);

  const value = useMemo(() => ({ state, setState }), [state]);

  return (
    <ActiveScreenContext.Provider value={value}>
      {children}
    </ActiveScreenContext.Provider>
  );
};
